import i18next from 'i18next';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

import s from './styles.module.scss';
import ChangesCol from './changes';

import type { ClinicLog } from 'infrastructure/classes/logs/clinic-log';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';

export const clinicLogColumns = (): IBaseTableColumns<ClinicLog> => {
  return [
    {
      label: i18next.t('labels.dateTime'),
      key: 'date',
      width: '100px',
      render(date) {
        const formattedDate = DateFormatter({
          date: new Date(date),
          format: DateFormats['MM-dd-yyyy | h:mm a'],
        });

        return <div className={s.date}>{formattedDate}</div>;
      },
    },
    {
      label: i18next.t('labels.operationType'),
      key: 'logType',
      width: '130px',
      responsive: ['md'],
      render(_) {
        return <div className={s.text}>UPDATE</div>;
      },
    },
    {
      label: i18next.t('labels.changes'),
      key: 'changes',
      render: (_, record) => <ChangesCol data={record} />,
    },
    {
      label: i18next.t('labels.user'),
      key: 'person',
      width: '220px',
      render(_, record) {
        return (
          <div className={s.text}>
            {record.person} {record.userType ? ` - ${record.userType}` : ''}
          </div>
        );
      },
    },
  ];
};
